// src/hooks/useLoadAvailablePlans.ts
import { useState, useEffect, useCallback } from "react";
import { useGetProjectGroupsAndPlansQuery } from "../redux/api";

export const useLoadGroupsAndPlans = (projectId: string) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetProjectGroupsAndPlansQuery(
        { project_id: projectId },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadGroupsAndPlans = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadGroupsAndPlans, isLoading, data, isError };
};